import { useDispatch } from "react-redux";
import CreateRoutes from "./routes";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useContext, useEffect, useState } from "react";
import { verifyAuth } from "./redux/slice/authSlice";
import { useSelector } from "react-redux";
import { getTheme } from "./redux/slice/themeSlice";
import {
  getOrganizationDetails,
  getOrganizationList,
} from "./redux/slice/organizationSlice";
import { checkPaymentGateway } from "./redux/slice/paymentAccountConnectSlice";
import useFindRoute from "./hooks/useFindRoute";
import { useTranslation } from "react-i18next";
import { langConfig } from "./config/LangConfig";
import { decrypt, decryptAlt, encrypt, encryptAlt } from "./helpers";
import { GoogleOAuthProvider } from "@react-oauth/google";

function App() {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { session } = useSelector((state) => state?.authProvider);
  const { lang } = useSelector((state) => state?.langProvider);
  const { eventId, lang: paramsLang } = useParams();
  const { matchedRoute, replaceParams } = useFindRoute();

  const { selectedOrganization, organizations } = useSelector(
    (state) => state?.organization
  );

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang);
    }
  }, [lang, i18n]);

  useEffect(() => {
    const accepted_lng = langConfig;
    const lng = localStorage.getItem("lang");
    if (lang && !accepted_lng?.includes(lang)) {
      localStorage.setItem("lang", "en");
      const path = replaceParams(matchedRoute, {
        lang: "en",
      });
      navigate(path);
    }
    if ((!paramsLang || paramsLang === undefined) && matchedRoute === "/") {
      navigate(`/${lng || "en"}`);
    }
    if (!accepted_lng?.includes(lng)) {
      localStorage.setItem("lang", "en");
    }
  }, [lang, paramsLang]);

  useEffect(() => {
    dispatch(getTheme());
  }, []);

  useEffect(() => {
    dispatch(verifyAuth());
  }, [location.pathname, session?.status]);

  useEffect(() => {
    if (session?.user?._id) {
      dispatch(getOrganizationList());
      dispatch(checkPaymentGateway({ userId: session?.user?._id }));
    }
  }, [session?.user?._id]);

  useEffect(() => {
    if (selectedOrganization) {
      dispatch(getOrganizationDetails(selectedOrganization));
    }
  }, [selectedOrganization]);

  useEffect(() => {
    if (eventId === undefined || !eventId) {
      for (let i = 0; i < sessionStorage.length; i++) {
        const key = sessionStorage.key(i);
        if (key && key.endsWith("-password")) {
          sessionStorage.removeItem(key);
          // Adjust index after removal
          i--;
        }
      }
    }
  }, []);

  return (
    <>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <HelmetProvider>
          <CreateRoutes />
        </HelmetProvider>
      </GoogleOAuthProvider>
    </>
  );
}

export default App;
